import "babel-polyfill";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/swiper.js";

import {binder, fwa} from "./libs/binder";
import {constants, alertBar, navFunction} from "./modules/module";
import {stickyHeader} from "./modules/stickyHeader";
import {customSelect} from "./modules/custom-select";
import {popups} from "./modules/popups";
import {resourcesSection} from "./modules/resources-section";
import {testimonialsSection} from "./modules/testimonials-section";
import {goToAnchor} from "./modules/go-to-anchor";
import {stickyWrappers} from "./modules/sticky-wrapper";
import {stickyNav} from "./modules/stickyNav";
import {parallax} from "./modules/parallax";
import {heroSection} from "./modules/hero-section";
import {addAnimations} from "./modules/add-animations";
import {marketoForm} from "./modules/marketo-form";
import {accordion} from "./modules/accordion";
import {tableSection} from "./modules/table-section";
import {popupLink} from "./modules/popupLink";
import {landingPopupPurple} from "./modules/landingPopupPurple";
import {landingPopupDruid} from "./modules/landingPopupDruid";

binder({
    bounds: {
        "html": [constants, alertBar],
        "body": [popups],
        ".header": [navFunction,stickyHeader],
        "select": customSelect,
        ".hero-section ": heroSection,
        ".resources-section": resourcesSection,
        ".testimonials-section": testimonialsSection,
        "[data-goto-anchor]": goToAnchor,
        ".sticky-wrapper": stickyWrappers,
        ".single-post .aside-nav.sticky": stickyNav,
        ".parallax": parallax,
        ".has-animation": addAnimations,
        "form": marketoForm,
        ".accordion": accordion,
        ".table-section": tableSection,
        ".popup-link": popupLink,
        ".landing-popup.purple": landingPopupPurple,
        ".landing-popup.druid": landingPopupDruid,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js